<template>
  <v-menu
    v-model="menuOpen"
    content-class="job-profile-actions-menu"
    location="bottom end"
    :close-on-content-click="true"
  >
    <template #activator="{ props: menuProps }">
      <DpplNewButton
        v-bind="menuProps"
        variant="outlined"
        height="40"
        class="job-profile-actions-trigger text-button-2"
        :disabled="disabled || loading"
        @click="handleOpenMenu"
      >
        {{ label }}
        <v-icon
          icon="$chevron-down"
          size="small"
          class="ml-1"
        />
      </DpplNewButton>
    </template>

    <div class="job-profile-actions-menu-inner d-flex flex-column">
      <button
        v-for="item in items"
        :key="item.value"
        type="button"
        class="job-profile-actions-item text-body-2"
        :class="{ delete: item.danger }"
        @click="handleSelect(item.value)"
      >
        {{ item.label }}
      </button>
    </div>
  </v-menu>
</template>

<script setup>
import { ref } from 'vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';

defineProps({
  items: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: 'Job Profile Actions',
  },
});

const emit = defineEmits(['open', 'select']);

const menuOpen = ref(false);

const handleOpenMenu = () => {
  emit('open');
};

const handleSelect = (value) => {
  menuOpen.value = false;

  emit('select', value);
};
</script>

<style scoped lang="less">
.job-profile-actions-trigger {
  min-width: 180px;
  color: @text-darkest;
  background: @white;
}
</style>

<style lang="less">
.job-profile-actions-menu {
  background: @stroke-default;
  border: 1px solid @stroke-default;
  border-radius: 4px;

  .job-profile-actions-menu-inner {
    gap: 1px;
    min-width: 180px;
  }

  .job-profile-actions-item {
    width: 100%;
    background: @white;
    padding: 8px 12px;
    color: @text-dark;
    cursor: pointer;
    text-align: left;

    &:hover {
      background: @bg-canvas;
    }

    &.delete {
      color: @text-error;
    }
  }
}
</style>
